// Domain-aware OAuth client selection.
//
// Context: during the migration from `book.stridesmobility.sg` to
// `book.stridespremier.com.sg`, we cannot add the new domain to the
// existing Google/Facebook OAuth clients — access to the Google Cloud
// project that owns the current client (640574078727) is not available.
//
// Approach: keep the existing OAuth clients untouched (so existing users
// on the old domain are unaffected), and create new OAuth clients under
// a project we do have access to (`strides-partner-development`). The
// frontend picks the appropriate client ID at runtime based on the
// current hostname.
//
// Safety notes verified before this change:
// - The frontend uses `react-google-login` (raw Google OAuth SDK), not
//   Firebase Auth, so the client ID can safely be switched at runtime.
// - The backend endpoint `/auth/loginG` in `strides-mobility-api` calls
//   Google's `userinfo` endpoint without validating the token's `aud`
//   (audience/client ID), and identifies users by email only. So the
//   same user logging in from either domain still lands on the same
//   account — no re-linking is required for existing users.
//
// Rollout:
// - Set `REACT_APP_GOOGLE_APP_ID_NEW` and `REACT_APP_FACEBOOK_APP_ID_NEW`
//   in production `.env` to the new client IDs (created under project
//   `strides-partner-development` with the new domain whitelisted).
// - If either _NEW variable is not set, the code falls back to the
//   existing client so behavior on the old domain never breaks.
const NEW_DOMAIN_HOSTNAME = 'book.stridespremier.com.sg';

const isNewDomain =
  typeof window !== 'undefined' &&
  window.location.hostname === NEW_DOMAIN_HOSTNAME;

const configService = {
  baseURL: process.env.REACT_APP_API_URL,
  facebookId:
    isNewDomain && process.env.REACT_APP_FACEBOOK_APP_ID_NEW
      ? process.env.REACT_APP_FACEBOOK_APP_ID_NEW
      : process.env.REACT_APP_FACEBOOK_APP_ID,
  googleMapApiKey: process.env.REACT_APP_GOOGLE_MAP_APP_KEY,
  googleLoginApiKey:
    isNewDomain && process.env.REACT_APP_GOOGLE_APP_ID_NEW
      ? process.env.REACT_APP_GOOGLE_APP_ID_NEW
      : process.env.REACT_APP_GOOGLE_APP_ID,
  stripePublicKey: process.env.REACT_APP_STRIPE_PUBLIC_KEY,
  timeout: 120000,
  maxImageSize: 10 * 1024 * 1024,
};

export { configService };
